export default theme => ({
  themesList: {
    paddingTop: 20,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 60,
    },
  },
  button: {
    margin: theme.spacing.unit,
  },
  floatingActionButton: {
    position: 'fixed',
    bottom: '23px',
    right: '23px',
    color: '#fff',
  },
  formControl: {
    width: '100%',
  },
  appBar: {
    position: 'fixed',
  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20,
  },
  colorPrimary: {
    backgroundColor: theme.palette.primary.main,
  },
  colorOnContactSelection: {
    backgroundColor: '#fff',
  },
  menuItem: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& $primary, & $icon': {
        color: theme.palette.common.white,
      },
    },
  },
  primary: {},
  menu: {
    width: 200,
  },
  formHelperText: {
    textAlign: 'right',
  },
  dateTimePickerLabel: {
    fontSize: '11.5px',
    lineHeight: 1,
  },
  root: {
    flexGrow: 1,
  },
  dialogContent: {
    [theme.breakpoints.up(600)]: {
      paddingTop: '64px',
    },
    [theme.breakpoints.down(600)]: {
      paddingTop: '48px',
    },
    overflowY: 'scroll',
    height: '100%',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    // [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
    //   width: 600,
    //   marginLeft: 'auto',
    //   marginRight: 'auto',
    // },
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    // padding: theme.spacing.unit * 2,
    // [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
    //   marginTop: theme.spacing.unit * 6,
    //   marginBottom: theme.spacing.unit * 6,
    //   padding: theme.spacing.unit * 3,
    // },
  },
  // cards: {
  //   marginTop: '10px',
  //   height: 330,
  //   overflowX: 'scroll',
  //   overflowY: 'hidden',
  //   whiteSpace: 'nowrap',
  // },
  templateFormCards: {
    marginTop: 27,
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      paddingTop: 60,
    },
  },
  templateFormCardsTask: {
    // marginTop: 27,
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
  },
  templateFormCardsModal: {
    // marginTop: 27,
  },
  card: {
    // maxWidth: 345,
    // height: 300,
    textAlign: 'left',
    // marginRight: 45,
    whiteSpace: 'normal',
  },
  media: {
    // height: 0,
    // paddingTop: '56.25%', // 16:9
  },
  gridListTile: {
    cursor: 'pointer',
  },
  // gridList: {
  //   flexWrap: 'nowrap',
  //   // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
  //   transform: 'translateZ(0)',
  // },
  gridListTitle: {
    color: '#fff',
  },
  titleBar: {
    background: 'transparent',
    textAlign: 'center',
  },
  tile: {
    background: '#eee',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
    borderRadius: '12px',
    '&:hover': {
      boxShadow: '0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
    },
  },
  hover: {},
  heading: {
    color: '#fff',
    fontSize: '90%',
    fontWeight: 'bold',
    marginRight: 7,
  },
  expandIcon: { color: '#fff' },
  expansionPanelSummary: { backgroundColor: theme.palette.secondary.main },
  expansionPanelGreen: { backgroundColor: theme.palette.green },
  phone: {
    border: 'solid #dddddd 35px',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    maxWidth: '500px',
    margin: 'auto',
  },
  phoneContainer: { margin: theme.spacing.unit * 2 },
  formPanel: {
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
  },
  tabs: {
    boxShadow: '0 0',
  },
  expansionPanelDetails: {
    flexGrow: 1,
    padding: 0,
    display: 'block',
  },
  chat: {
    margin: 0,
    maxWidth: 'initial',
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
  textField: {
    margin: '12px',
  },
  bottomNav: {
    position: 'fixed',
    bottom: 0,
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
    width: '100vw',
    left: 0,
    zIndex: 3,
  },
  bottomNavModal: {
    position: 'fixed',
    bottom: 0,
    [theme.breakpoints.down('sm')]: {
      bottom: 60,
    },
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
    width: '100vw',
    left: 0,
    zIndex: 3,
  },
  bottomNavAction: {
    minWidth: '65px',
    padding: 0,
  },
  bottomNavActionSelected: {
    color: '#fff !important',
    backgroundColor: '#003a71',
    fontSize: '0.75rem !important',
    paddingTop: '0 !important',
  },
  bottomNavLabel: {
    color: '#fff',
  },
  bottomNavNoMargin: {
    position: 'fixed',
    bottom: 0,
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
    // width: '100vw',
    // left: 0,
    zIndex: 2,
    [theme.breakpoints.down('sm')]: {
      left: 0,
      width: '100vw',
    },
    [theme.breakpoints.up('sm')]: {
      left: 80,
      width: 'calc(100vw - 80px)',
    },
  },
  bottomNavNoMarginMobile: {
    position: 'absolute',
    bottom: 0,
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
    // width: '100vw',
    // left: 0,
    zIndex: 3,
    width: '100%',
    // [theme.breakpoints.down('sm')]: {
    //   left: 0,
    //   width: '100%',
    // },
    // [theme.breakpoints.up('sm')]: {
    //   left: 55,
    //   width: 'calc(100% - 55px)',
    // },
  },
  bottomNavDialog: {
    position: 'absolute',
    bottom: 45,
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
    // width: '100vw',
    // left: 0,
    zIndex: 3,
    width: '100%',
    // [theme.breakpoints.down('sm')]: {
    //   left: 0,
    //   width: '100%',
    // },
    // [theme.breakpoints.up('sm')]: {
    //   left: 55,
    //   width: 'calc(100% - 55px)',
    // },
  },
  notchedOutline: {
    borderRadius: 28,
    paddingLeft: '40px !important',
  },
  notchedOutlineWarning: {
    borderRadius: 28,
    paddingLeft: '40px !important',
    borderColor: `${theme.palette.orange} !important`,
  },
  icon: { fontSize: '1rem' },
  color: { color: '#fff' },
  error: { color: theme.palette.red },
  headingIcon: {
    fontSize: '1rem',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  bottomNavEditor: {
    // color: '#fff !important',
    backgroundColor: '#18B940',
    // fontSize: '0.75rem !important',
    // paddingTop: '0 !important',
  },
  bottomNavEditorSelected: {
    color: '#fff !important',
    backgroundColor: '#167f3b',
    fontSize: '0.75rem !important',
    paddingTop: '0 !important',
  },
  // cardsMarginTop: {
  //   marginTop: 60,
  //   [theme.breakpoints.down('sm')]: {

  //   }
  // },

  text: {
    color: theme.palette.secondary.main,
    marginBottom: 10,
    fontSize: 13,
  },
  section: { marginBottom: 10 },
  task: {
    cursor: 'grab',
    padding: '10px 0px 12px 10px',
    fontSize: 13,
    color: '#49466a',
    backgroundColor: '#fff',
    border: '2px solid #49466a',
    borderRadius: 35,
    display: 'inline-block',
    margin: 5,
    '&:hover': {
      backgroundColor: '#eee',
    },
  },
  taskDisabled: {
    cursor: 'default',
    backgroundColor: '#edf5fe',
    color: '#787878',
    border: '2px solid #787878',
    padding: '10px 0px 12px 10px',
    fontSize: 13,
    borderRadius: 35,
    display: 'inline-block',
    margin: 5,
  },
  taskIcon: {
    marginRight: 5,
    marginBottom: '-7px',
    fontSize: 22,
  },
  dragIcon: {
    fill: '#8e95af',
    cursor: 'grab',
  },
  dragIconDisabled: {
    cursor: 'default',
  },
  rounded: {
    borderRadius: 28,
    overflowY: 'hidden',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
      overflowY: 'auto',
    },
  },
})
